module.exports = __webpack_public_path__ + "static/animazione_high-8877333cdc1cc11bb29c3b6610099102.mp4";